import { Fade, Box, Typography, TextField, RadioGroup, Radio, Button, FormControlLabel, useMediaQuery } from "@mui/material";
import { FC, useEffect, useRef } from "react";

interface Step3Props {
    activeStep: number;
    defectCircumstances: string;
    defectDescription: string;
    claimType: string;
    handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
    handleNext: () => void;
    handleBack: () => void;
}

const Step3: FC<Step3Props> = ({
    activeStep,
    defectCircumstances,
    defectDescription,
    claimType,
    handleChange,
    handleNext,
    handleBack
}) => {
    const stepRef = useRef<HTMLDivElement>(null);
    const isMobile = useMediaQuery("(max-width:550px)");

    useEffect(() => {
        if (activeStep === 2 && stepRef.current && isMobile) {
            const top = stepRef.current.getBoundingClientRect().top + window.scrollY - 80;
            window.scrollTo({ top, behavior: "smooth" });
        }
    }, [activeStep, isMobile]);
    return (
        <Fade in={activeStep === 2} unmountOnExit>
            <Box sx={{ display: activeStep === 2 ? "flex" : "none", flexDirection: "column", gap: 2 }}>
                <Typography variant="h6" fontWeight={600} color="#bfa14b" mb={1} ref={stepRef}>
                    Opis reklamacji
                </Typography>
                <TextField
                    label="Okoliczności stwierdzenia wady"
                    name="defectCircumstances"
                    value={defectCircumstances}
                    onChange={handleChange}
                    required
                    multiline
                    minRows={2}
                />
                <TextField
                    label="Opis wady"
                    name="defectDescription"
                    value={defectDescription}
                    onChange={handleChange}
                    required
                    multiline
                    minRows={2}
                />
                <RadioGroup
                    row
                    name="claimType"
                    value={claimType}
                    onChange={handleChange}
                    sx={{ mt: 1 }}
                >
                    <FormControlLabel value="1" control={<Radio sx={{ color: "#bfa14b", '&.Mui-checked': { color: "#bfa14b" } }} />} label="Rękojmia" />
                    <FormControlLabel value="2" control={<Radio sx={{ color: "#bfa14b", '&.Mui-checked': { color: "#bfa14b" } }} />} label="Gwarancja producenta" />
                </RadioGroup>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                    <Button
                        variant="outlined"
                        sx={{
                            borderColor: "#bfa14b",
                            color: "#bfa14b",
                            fontWeight: 600,
                            borderRadius: 2,
                            "&:hover": { borderColor: "#a88d36", color: "#a88d36" }
                        }}
                        onClick={handleBack}
                    >
                        Wstecz
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: "#bfa14b",
                            color: "#fff",
                            fontWeight: 600,
                            px: 4,
                            borderRadius: 2,
                            boxShadow: "0 2px 8px rgba(191,161,75,0.12)",
                            "&:hover": { bgcolor: "#a88d36" }
                        }}
                        onClick={handleNext}
                        disabled={
                            !defectCircumstances ||
                            !defectDescription ||
                            !claimType
                        }
                    >
                        Dalej
                    </Button>
                </Box>
            </Box>
        </Fade>
    )
}

export default Step3;